import React from 'react';
import './Teleconsultation.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faVideo,
  faClock,
  faLaptopMedical,
  faShieldAlt,
  faUserMd,
  faHome
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const Teleconsultation: React.FC = () => {
  const { t } = useTranslation();

  const features = t('teleconsultation.features', {
    returnObjects: true
  }) as { title: string; description: string }[];

  const icons = [
    faVideo,
    faClock,
    faLaptopMedical,
    faShieldAlt,
    faUserMd,
    faHome
  ];

  return (
    <section className="teleconsultation" id="teleconsultation">
      <div className="container">
        <h2 >{t('teleconsultation.title')}</h2>

        <div className="teleconsultation-text">
          <p>{t('teleconsultation.paragraph')}</p>
        </div>

        <div className="teleconsultation-content">
          <div className="teleconsultation-features">
            {features.map((feature, index) => (
              <div key={index} className="feature-item">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={icons[index]} />
                </div>
                <h3 >{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>

          <div className="teleconsultation-image">
            <img
              src="/images/rand1.jpg"
              alt={t('teleconsultation.title')}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Teleconsultation;
